<html>
<div class="container-fluid">


    <div class="row">
      <div class="col-12">
        <!-- Right Sidebar -->
        <div >

          <div class="card">
              <div class="media mb-4">
                <img class="d-flex me-3  avatar-sm" src="assets/images/avatarsys2026.png"
                  alt="Icono">
                <div class="media-body">
                  <h5 class="font-size-14 mt-1">{{this.data.PAD14NEM}}</h5>
                  <small class="text-muted">{{this.data.PAD14EFR}}</small>
                  <br>
                  <small class="text-muted">{{this.data.PAD14FEV}}</small>
                </div>
              </div>
              <div class="alert show alert-secondary fade">{{this.data.PAD14ASU}}</div>
              <div [innerHtml]="this.data.PAD14TXT"></div>
          </div>
        </div>
        <!-- card -->
      </div>
    </div>
  </div>
  </html>